class GlobalFlyout {
    constructor() {
        this.state = {
            namespace: null,
            setNamespace: (stateObject, namespace) => {
                stateObject.namespace = namespace;
            }
        };

        this.actions = {
            hideOtherElements: (buttonsClass, commonParent, reference, visibilityClass, excludeClass) => {
                const elements = reference.closest(`.${commonParent}`).querySelectorAll(`.${buttonsClass}`);

                elements.forEach(element => {
                    if(element.classList.contains(visibilityClass)) {
                        if (!element.classList.contains(excludeClass)) {
                            element.classList.remove(visibilityClass);
                        }
                    }
                })
            }
        };

        this.options = {
            namespace: '',
            menuItems: [
                {
                    className: 'button-contact',
                    visible: true,
                    event: {
                        callback: e => {
                            const button = e.currentTarget.closest(`.button-contact`);

                            this.actions.hideOtherElements('button', 'global-flyout', button, 'show', 'button-contact');
                            button.classList.toggle('show');
                        },
                        type: ['mouseenter', 'mouseleave']
                    }
                }
            ]
        }
    }

    init(overwriteOptions) {
        this.options = Object.assign(this.options, overwriteOptions);

        if (this.options.namespace) {
            this.state.setNamespace(this.state, `.${this.options.namespace} `);
        } else {
            this.state.setNamespace(this.state, '');
        }

        this.options.menuItems.forEach(menuItem => {
            const menuItemReference = document.querySelector(`${this.state.namespace}.${menuItem.className}`);
            if (menuItemReference) {
                if (menuItem.visible) {
                    if (!('ontouchstart' in document.documentElement)) {
                        if (menuItem.event.type instanceof Array) {
                            menuItem.event.type.forEach(event => {
                                menuItemReference.addEventListener(event, menuItem.event.callback);
                            });
                        } else {
                            menuItemReference.addEventListener(menuItem.event.type, menuItem.event.callback);
                        }
                    }
                }
                else {
                    menuItemReference.style.display = 'none';
                }
            }
        });
    }
}

export { GlobalFlyout }
